import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import HeaderBar from '../../components/HeaderBar/HeaderBar'
import SearchBox from './Search/SearchBox'
import { useAppSelector } from '../../hooks/useAppSelector'
import { ResultsBox } from './Results'
import './Results.css'

export const ResultsPage: React.FC = () => {
  const session = useAppSelector((state) => state.session.data)
  const isAdmin = Boolean(session.user?.administrator)
  const currentUserId =
    typeof session.user?.id === 'number' ? session.user.id : null

  return (
    <Container fluid={true} className="wivi-container">
      <Row>
        <Col xs={12}>
          <HeaderBar
            origin="IPA"
            routes={[
              {
                title: 'Results'
              }
            ]}
            help={{
              title: 'Results Help',
              text: (
                <>
                  <p>
                    The results page lists IPA analysis outputs. Use the search
                    filters to narrow by analyzer type, analyzer, or date range.
                    Only the analyzer type filter is required.
                  </p>
                  <p>
                    Administrators can include results for all users.
                    Non-administrators are limited to their own results.
                  </p>
                </>
              )
            }}
          />
        </Col>
      </Row>
      <Row>
        <SearchBox isAdmin={isAdmin} currentUserId={currentUserId} />
      </Row>
      <Row className="mt-3">
        <Col xs={12}>
          <ResultsBox />
        </Col>
      </Row>
    </Container>
  )
}

export default ResultsPage
